module.exports = __webpack_public_path__ + "frontend/img/icon_question_mark.5a4a884f.svg";